import styled from 'styled-components';

import { gridSizes, media, weights, zIndexses } from 'utils/style';
import Summary from './container';

export default styled(Summary)`
  .insurance-checkbox {
    position: relative;
  }
  label[for^='checkbox_HAS_INSURANCE'] {
    position: absolute;
    width: 40.2rem;
    z-index: ${zIndexses.summary};
  }
  span.label {
    margin-left: 2rem;
  }

  ${media.lessThan('extraSmall')`
    background: var(--white-caniche);
  `};

  .btn-container {
    text-align: right;
    margin: ${gridSizes('XL')} 0;
    ${media.lessThan('extraSmall')`
      padding: initial;
      margin: ${gridSizes('L')} 0;
      button{
        width: 100%;
        text-align: center;
      }
    `};
  }

  .summary-item {
    border-radius: ${gridSizes('S')};
    border: solid 1px var(--grey-mouse);
    padding: ${gridSizes('L')};
    margin: ${gridSizes('L')} 0;

    h1 {
      font-size: ${gridSizes('L')};
      line-height: 28px;
      color: var(--grey900);
      font-weight: ${weights('medium')};
      margin: 0;

      ${media.lessThan('extraSmall')`
        font-size: 20px;
        line-height: ${gridSizes('L')};
      `};
    }

    ${media.lessThan('extraSmall')`
      background: var(--white);
      margin: 4px;
      border: none;
      margin-bottom: 0px;
      border-radius: 2px;
      padding: ${gridSizes('L')} 18px;
    `};
  }

  .summary-stops {
    border-radius: ${gridSizes('S')};
    border: solid 1px var(--grey-mouse);
    padding: 0 ${gridSizes('L')};
    margin: ${gridSizes('L')} 0;
    ${media.lessThan('extraSmall')`
      background: var(--white);
      margin: 0 4px;
      border: none;
      border-radius: 0 0 2px 2px;
      padding: 0 12px;
    `};
  }

  .summary-item-mobile {
    ${media.lessThan('extraSmall')`
      background: var(--white);
      border-radius: 2px;
      margin: 4px;
      padding: 12px 18px;
      margin-bottom: 6px;

      h1 {
        font-size: 20px;
        line-height: ${gridSizes('L')};
        ${media.lessThan('small')`
        font-size: ${gridSizes('L')};
        `};
      }
      .summary-item {
        border: none;
        padding: 0px;
        padding-bottom: ${gridSizes('L')};
        padding: 0px;
        margin: 0;
      }
    `};
  }

  .summary-xdock-print-required {
    background-color: var(--deep-purple100);
    border: 1px solid var(--deep-purple700);
    padding: 1.6rem;
    border-radius: 0.4rem;
    display: flex;
    margin-bottom: 2.4rem;
    div {
      width: 100%;
      margin-left: 1.6rem;
    }
    svg {
      fill: var(--deep-purple900);
    }
  }

  .summary-shipper-instructions {
    background-color: var(--primary100);
    border: 1px solid var(--primary300);
    padding: 1.6rem;
    border-radius: 0.4rem;
    margin-bottom: 2.4rem;
    color: var(--grey900);
    position: relative;
    div {
      margin-left: 3.8rem;
    }
    svg {
      fill: red;
    }
    p {
      color: var(--grey900);
      margin: 0;
    }
    strong {
      font-weight: 500;
    }
    a {
      color: var(--grey900);
      font-style: normal;
      font-weight: 500;
    }
    img {
      width: 2.4rem;
      height: 2.4rem;
      position: absolute;
      top: 1.8rem;
      left: 1.2rem;
    }
  }

  .recurring-summary-item-container {
    border-radius: ${gridSizes('S')};

    margin: ${gridSizes('L')} 0;
    border-radius: ${gridSizes('S')};
    overflow: hidden;

    .summary-item {
      ${media.lessThan('small')`
       border: none;
       margin: 0px;
       `};
    }

    ${media.lessThan('small')`
    background: initial;
      border: none;

      h1{
        font-size: ${gridSizes('M')};
      }
    `};
  }

  .as-link {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    font-size: ${gridSizes('M')};
    color: var(--grey700);
    font-weight: ${weights('medium')};
  }

  p {
    color: var(--grey700);
  }
`;
